export type TemplateLibraryOption = { label: string; value: string };

type TemplatesSelectResult = { templates: Array<{ name: string; content: string }> };

let cache: TemplatesSelectResult | null = null;
let inflight: Promise<TemplatesSelectResult> | null = null;

export function mapTemplatesToOptions(templates: Array<{ name: string; content: string }>): TemplateLibraryOption[] {
  return templates.map(t => ({ label: t.name, value: t.content }));
}

/** Synchronous read — non-null when the library has already been fetched this session. */
export function getTemplatesSelectCache(): TemplatesSelectResult | null {
  return cache;
}

export function invalidateTemplatesSelectCache() {
  cache = null;
  inflight = null;
}

/**
 * Fetch templates for picker dropdowns. Dedupes concurrent calls and caches the result
 * so multiple TemplateLibrarySelect instances share one API request.
 */
export async function fetchTemplatesForSelect(
  paginate: (params: Record<string, unknown>, slug?: string) => Promise<{ templates?: Array<{ name: string; content: string }> } | undefined>,
): Promise<TemplatesSelectResult> {
  if (cache) return cache;
  if (inflight) return inflight;

  inflight = paginate(
    { page: 1, pageSize: 200, getAll: 'yes' },
    'paginateTemplatesSelect',
  )
    .then(result => {
      const data: TemplatesSelectResult = { templates: result?.templates ?? [] };
      cache = data;
      return data;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}
